<template>
<vx-card title="Şirket Hiyerarşisi" code-toggler >
  <div>
    <organization-chart :datasource="ds" @node-click="deneme"></organization-chart>
  </div>
</vx-card>
</template>
 
<script>
  import OrganizationChart from 'vue-organization-chart'
  import 'vue-organization-chart/dist/orgchart.css'
 
  export default {
    components: {
      OrganizationChart
    },
    data () {
      return {
        ds: {
          'id': '1',
          'name': 'İbrahim Takıl',
          'title': 'Kurucu-Yönetici',
          'children': [
            { 'id': '2', 'name': 'EcuTest', 'title': 'Departmanı',
            'children': [
                { 'id': '4', 'name': 'Emre Kızmaz', 'title': 'electric electronics engineer' }                
               ]
            },

            { 'id': '3', 'name': ' Yazılım', 'title': ' Departmanı',
              'children': [
                { 'id': '4', 'name': ' ', 'title': 'senior engineer' },
                { 'id': '5', 'name': '  ', 'title': 'senior engineer'},
                 { 'id': '4', 'name': '  ', 'title': 'kıdemli junior engineer' },
                 { 'id': '4', 'name': '  ', 'title': 'junior engineer' },
               ]
             },
            { 'id': '8', 'name': 'Mimarlık ve Çizim', 'title': 'Departmanı',
            'children': [
                { 'id': '9', 'name': 'Beyza Kaplan', 'title': 'architect' }                
               ]
            },
          ]
        }
      }

    },
    methods:{
    }
  }
</script> 
